var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 7.25L3.48474 5.02454C3.06151 4.69389 2.84989 4.52856 2.69776 4.3259C2.56296 4.14633 2.46286 3.94596 2.40201 3.73393C2.33333 3.49462 2.33333 3.23637 2.33333 2.71988V1M6.33333 7.25L9.18192 5.02454C9.60516 4.69389 9.81677 4.52856 9.96891 4.3259C10.1037 4.14633 10.2038 3.94596 10.2647 3.73393C10.3333 3.49462 10.3333 3.23637 10.3333 2.71988V1M6.33333 7.25L3.48474 9.47546C3.06151 9.80611 2.84989 9.97144 2.69776 10.1741C2.56296 10.3537 2.46286 10.554 2.40201 10.7661C2.33333 11.0054 2.33333 11.2636 2.33333 11.7801V13.5M6.33333 7.25L9.18192 9.47546C9.60516 9.80611 9.81677 9.97144 9.96891 10.1741C10.1037 10.3537 10.2038 10.554 10.2647 10.7661C10.3333 11.0054 10.3333 11.2636 10.3333 11.7801V13.5M1 1H11.6667M1 13.5H11.6667",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.e8728d8b0ba91f877d4c1c399a5e4920.svg";
export { ForwardRef as ReactComponent };